module.exports = __webpack_public_path__ + "img/8.f072a1ea.jpg";